module.exports = __webpack_public_path__ + "media/images/icons/flags/GB-2-6689fc004eb5701cbbcb7bd48ac015ad.svg";